import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { OrganizationServiceRow } from "../organizationServicesViewConfig";

interface OrganizationServiceActionsCallbacks {
    onEditService: (serviceId: string) => void;
    onDeleteService: (serviceId: string) => void;
}

type OrganizationServiceActionsMeta = ViewTableMeta<
    OrganizationServiceActionsCallbacks,
    never
>;

export const OrganizationServiceActionsCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, OrganizationServiceRow, string>) => {
        const meta = (table.options.meta ??
            {}) as OrganizationServiceActionsMeta;
        const serviceId = row.original.id;

        if (
            !meta.callbacks?.onEditService ||
            !meta.callbacks?.onDeleteService
        ) {
            return null;
        }

        return (
            <ViewTableCell captureClicks>
                <Menu.More className={viewTableStyles.showOnHover}>
                    <Menu.Item
                        onClick={() => meta.callbacks?.onEditService(serviceId)}
                    >
                        Edit
                    </Menu.Item>
                    <Menu.Item
                        destructive
                        onClick={() =>
                            meta.callbacks?.onDeleteService(serviceId)
                        }
                    >
                        Delete
                    </Menu.Item>
                </Menu.More>
            </ViewTableCell>
        );
    },
);
